module.exports = __webpack_public_path__ + "media/images/subject_img/GEOGRAPHY-6144371e187f2ce9ef2421f2be637c0b.jpg";